




























































import Vue from 'vue';
import i18n from 'vue-i18n';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';

Vue.use(i18n);

export default {
    name: 'CoLegalLinks',
    components: { CoDropdown, CoDropdownItem },
    computed: {
        isInMobile() {
            return !!this.$store?.state?.isInMobile;
        },
        // Read the shared settings reactively so saving a legal toggle updates the footer immediately.
        legalSettings() {
            return this.$store?.state?.space || {};
        },
        hasMoreLegalLinks() {
            return (
                !this.legalSettings.TermsAndConditionsOff ||
                !this.legalSettings.AccessibilityPolicyOff ||
                this.legalSettings.PurchaseCancellationPolicyOn ||
                this.legalSettings.PurchaseCancellationFormOn
            );
        },
    },
};
